import { render } from "./leaderboardView.vue?vue&type=template&id=6953ad9a&scoped=true"
import script from "./leaderboardView.vue?vue&type=script&lang=js"
export * from "./leaderboardView.vue?vue&type=script&lang=js"

import "./leaderboardView.vue?vue&type=style&index=0&id=6953ad9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6953ad9a"]])

export default __exports__